module.exports = __webpack_public_path__ + "img/ogatev8.3acf0aa8.png";